import { render, staticRenderFns } from "./ManagePaymentMethod.vue?vue&type=template&id=6c6c0b11&"
import script from "./ManagePaymentMethod.vue?vue&type=script&lang=js&"
export * from "./ManagePaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports